import { styled } from '@mui/material';

export const Styles = {
  InputContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '100% !important'
    }
  })),

  FormSection: styled('section')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: '10px',
    marginBottom: '20px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '20px'
    }
  })),

  CheckboxContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    [theme.breakpoints.down('sm')]: {
      gap: '8px'
    }
  })),

  CheckboxRow: styled('div')(({ theme }) => ({
    display: 'flex',
    gap: '24px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '8px'
    }
  })),

  CheckboxGridGroup: styled('div')(({ theme }) => ({
    display: 'grid',
    gap: '24px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '8px'
    }
  })),

  CheckboxGridTwoCols: styled('div')(({ theme }) => ({
    display: 'grid',
    gap: '24px',
    gridTemplateColumns: 'repeat(2, 1fr)',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '8px'
    }
  })),

  CheckboxInput: styled('input')(({ theme }) => ({
    width: '18px',
    height: '18px',
    margin: 0,
    cursor: 'pointer',
    accentColor: '#04682E',
    '&:focus': {
      outline: '2px solid #04682E',
      outlineOffset: '2px'
    },
    [theme.breakpoints.down('md')]: {
      width: '16px',
      height: '16px'
    }
  })),

  CheckboxLabel: styled('label')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '15px',
    color: '#000000ff',
    cursor: 'pointer',
    transition: 'color 0.2s',
    '&:hover': {
      color: '#04682E'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  })),

  OwnerInputRow: styled('div')(({ theme }) => ({
    display: 'flex',
    paddingBottom: '15px',
    flexDirection: 'row',
    gap: '10px',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '20px'
    }
  })),

  PageContainer: styled('div')({
    backgroundColor: '#ebebeb',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }),

  ContentContainer: styled('div')({
    maxWidth: '1010px',
    width: '100%',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    padding: '20px',
    display: 'flex',
    gap: '40px'
  }),
  MainContent: styled('div')({
    display: 'flex',
    width: '1200px',
    margin: '0 auto',
    flexDirection: 'row'
  }),
  PageContent: styled('div')({
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '20px'
  }),
  RectangleBar: styled('div')({
    width: '100%',
    height: '2px',
    backgroundColor: '#04682E',
    margin: '10px 0'
  }),

  FormColumn: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  }),

  Label: styled('label')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '11px',
    lineHeight: '25px',
    color: '#212529',
    textTransform: 'uppercase',
    '&.required::after': {
      content: '"*"',
      color: '#FF0000',
      margin: '5px'
    }
  }),

  Input: styled('input')(({ theme }) => ({
    width: '100%',
    padding: '10px',
    fontSize: '13px',
    border: '1px solid black',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    '&:focus': {
      outline: 'none',
      borderColor: 'black'
    },
    [theme.breakpoints.down('md')]: {
      padding: '8px',
      fontSize: '14px'
    }
  })),

  TextArea: styled('textarea')({
    width: '100%',
    padding: '10px',
    fontSize: '14px',
    border: '1px solid black',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    resize: 'vertical',
    minHeight: '121px',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    }
  }),
  Select: styled('select')({
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    border: '1px solid black',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    }
  }),
  Button: styled('button')({
    padding: '10px 30px',
    fontSize: '16px',
    backgroundColor: '#125dae',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#0B327A'
    }
  }),
  CancelButton: styled('button')({
    padding: '10px 30px',
    fontSize: '16px',
    backgroundColor: '#FF0000',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FF0001'
    }
  }),
  OwnerSection: styled('section')({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '20px'
  }),

  StatusSection: styled('div')({
    marginBottom: '20px'
  }),
  StatusRow: styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '40px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '10px'
    }
  })),
  FieldBlock: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    minWidth: '220px',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      width: '100%'
    }
  })),
  ToggleContainer: styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  }),
  ToggleLabel: styled('span')({
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '27px',
    color: '#212529',
    textTransform: 'uppercase'
  }),
  Switch: styled('label')({
    position: 'relative',
    display: 'inline-block',
    width: '44px',
    height: '24px'
  }),
  SwitchInput: styled('input')({
    opacity: 0,
    width: 0,
    height: 0,
    '&:checked + span': {
      backgroundColor: '#04682E'
    },
    '&:focus + span': {
      boxShadow: '0 0 1px #04682E'
    },
    '&:checked + span:before': {
      transform: 'translateX(20px)'
    }
  }),
  SwitchSlider: styled('span')({
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#ccc',
    transition: '.2s',
    borderRadius: '24px',
    '&:before': {
      position: 'absolute',
      content: '""',
      height: '18px',
      width: '18px',
      left: '3px',
      bottom: '3px',
      backgroundColor: 'white',
      transition: '.2s',
      borderRadius: '50%'
    }
  }),
  RadioContainer: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  }),
  RadioRow: styled('div')({
    display: 'flex',
    gap: '20px'
  }),
  RadioLabel: styled('label')({
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    fontSize: '16px'
  }),
  RadioInput: styled('input')({
    margin: '0'
  })
};
